import { useAlert } from "react-alert";

export const printDocument = (config) => {
    const {
        pdfRef,
        title,
        formType = 'form',
        userData = {},
        onError
    } = config;

    try {
        const printWindow = window.open('', '_blank');
        const pdfElement = pdfRef.current;

        if (!pdfElement) {
            const errorMsg = 'PDF content not ready for printing';
            if (onError) {
                onError(errorMsg);
            } else {
                console.error(errorMsg);
            }
            return;
        }

        const printContent = pdfElement.innerHTML;
        const documentTitle = title || `${userData.firstname || 'Document'} - ${formType} Form`;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${documentTitle}</title>
                <style>
                    ${getPrintStyles()}
                </style>
            </head>
            <body>
                ${printContent}
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);

    } catch (error) {
        const errorMsg = `Failed to print document: ${error.message}`;
        if (onError) {
            onError(errorMsg);
        } else {
            console.error(errorMsg);
        }
    }
};

const getPrintStyles = () => {
    return `
        body { 
            font-family: Arial, sans-serif; 
            margin: 0; 
            padding: 20px;
            background: white;
        }
        .pdf-container {
            width: 100%;
            max-width: none;
        }
        .row { 
            display: flex; 
            flex-wrap: wrap; 
            margin: 0 -15px; 
        }
        .col-1, .col-2, .col-3, .col-4, .col-6, .col-8, .col-10, .col-12 {
            padding: 0 15px;
            box-sizing: border-box;
        }
        .col-1 { width: 8.33%; }
        .col-2 { width: 16.66%; }
        .col-3 { width: 25%; }
        .col-4 { width: 33.33%; }
        .col-6 { width: 50%; }
        .col-8 { width: 66.66%; }
        .col-10 { width: 83.33%; }
        .col-12 { width: 100%; }
        .input-container { margin-bottom: 15px; }
        .input-container label { 
            display: block; 
            margin-bottom: 5px; 
        }
        .input1 { 
            border: 1px solid #ccc; 
            padding: 8px; 
            min-height: 20px;
            background: white;
        }
        .side-head label{ font-weight: bold; }
        .side-head { margin: 20px 0 10px 0; }
        .lines { border: 1px solid #333; }
        .peace-image { height: 60px; }
        .dialysis-head { text-align: center; flex: 1; margin: 0; }
        .dialysis-profile img { width: 100px; height: 120px; object-fit: cover; }
        .relative-table, .relative2-table { 
            border: 1px solid #ccc; 
            padding: 8px; 
            text-align: center; 
        }
        .t2-color { background-color: #f0f0f0; font-weight: bold; }
        @page { margin: 1cm; }
        @media print {
            body { print-color-adjust: exact; }
            .pdf-container { page-break-inside: avoid; }
        }
    `;
};

export const usePrint = (config) => {
    const alert = useAlert();

    const handlePrint = () => {
        printDocument({
            ...config,
            onError: (errorMsg) => {
                alert.error(errorMsg);
            }
        });
    };

    return handlePrint;
};

export const withPrint = (WrappedComponent) => {
    return function PrintableComponent(props) {
        const alert = useAlert();

        const handlePrint = (config) => {
            printDocument({
                ...config,
                onError: (errorMsg) => {
                    alert.error(errorMsg);
                }
            });
        };

        return <WrappedComponent {...props} handlePrint={handlePrint} />;
    };
};